import axios from '../utils/http'

// 手机号密码登录
export const apiSignIn = (params) => {
    return axios.post('/signin', params)
}

// 手机号密码登录
export const apiSmsSignIn = (params) => {
    return axios.post('/smsSignin', params)
}

// 获取二维码token
export const apiGenWeappLoginToken = () => {
    const time = new Date().getTime()
    return axios.get('/genWeappLoginToken', {params: {'t': time}})
}
// 登录轮循
export const apiQueryWeappQrcodeStatus = (params) => {
    const time = new Date().getTime()
    return axios.get('/queryWeappQrcodeStatus', {params: {...params, time}})
}
// 获取用户信息
export const apiUserInfo = () => {
    const time = new Date().getTime()
    return axios.get('/user/info', {params: time})
}

// 获取账户分组列表
export const apiGroups = () => {
    const time = new Date().getTime()
    return axios.get('/groups', {params: time})
}

// 创建账户分组
export const apiCreateGroups = (params) => {
    return axios.post('/groups', params)
}

// 创建账户分组
export const apiUpdateGroups = (id, params) => {
    return axios.put(`/groups/${id}`, params)
}

// 删除账户分组
export const apiDeleteGroups = (id) => {
    return axios.delete(`/groups/${id}`)
}

// 获取账户列表
export const apiAccounts = () => {
    const time = new Date().getTime()
    return axios.get('/accounts', {params: time})
}

// 查询账户信息
export const apiGetAccount = (id) => {
    const time = new Date().getTime()
    return axios.get(`/accounts/${id}`, {params: time})
}

// 新增账户
export const apiCreateAccount = (params) => {
    return axios.post(`/accounts`, params)
}

// 修改账户
export const apiUpdateAccount = (id, params) => {
    return axios.put(`/accounts/${id}`, params)
}

// 删除账户
export const apiDeleteAccount = (id) => {
    return axios.delete(`/accounts/${id}`)
}

// 获取品种分组列表
export const apiVarietyGroups = () => {
    const time = new Date().getTime()
    return axios.get('/variety-groups', {params: time})
}

// 创建品种分组
export const apiCreateVarietyGroups = (params) => {
    return axios.post('/variety-groups', params)
}

// 更新品种分组
export const apiUpdateVarietyGroups = (id, params) => {
    return axios.put(`/variety-groups/${id}`, params)
}

// 删除品种分组
export const apiDeleteVarietyGroups = (id) => {
    return axios.delete(`/variety-groups/${id}`)
}